import goals from "@gtmhub/goals/goals.module";
import { ItemsTreeService } from "./items-tree-service";
import { AlignmentLoader } from "./alignmentLoader";
import { AlignmentTreeCtrl } from "./states/alignment-tree-ctrl";
import { AlignmentNestedCtrl } from "./states/alignment-nested-ctrl";
import { AlignmentSidebarCtrl } from "./states/alignment-sidebar-ctrl";
import { NestedViewOKRNodeComponent } from "./components/nested-view-okr-node/nested-view-okr-node.component";
import { NestedTreeService } from "../alignment-tree/service/nested-tree-service";

const mod = angular.module("alignment-tree", [goals]);
mod.service("ItemsTreeService", ItemsTreeService);
mod.service("AlignmentLoader", AlignmentLoader);
mod.service("NestedTreeService", NestedTreeService);
mod.controller("AlignmentTreeCtrl", AlignmentTreeCtrl);
mod.controller("AlignmentNestedCtrl", AlignmentNestedCtrl);
mod.controller("AlignmentSidebarCtrl", AlignmentSidebarCtrl);
mod.component("nestedViewOkrNode", NestedViewOKRNodeComponent);

export default mod.name;
